import CategoryListing from "@/components/categoryListing/CategoryListing.vue";
import SetItemsForTrackModal from "@/components/setItemsForTrack/setItemsForTrack.vue";
import { CategoryService } from "@/services/categoryApi";
import BooleanModal from "@/components/booleanModal/booleanModal.vue";
import { isAverageComparison, comparator } from "@/utils";
import { createNamespacedHelpers } from "vuex";

const { mapGetters: filtersGetters } = createNamespacedHelpers("filters");

export default {
	components: {
		CategoryListing,
		SetItemsForTrackModal,
		BooleanModal,
	},

	data() {
		return {
			categoryOverviewData: {},
			categoryOverviewDataStatus: {
				showLoader: true,
				dataLoadFailed: false,
			},
			wasteSourceWithTranslations: {},
			showItemsForTrackModal: false,
			printReportOpen: false,
			generateExcelModalShown: false,
		};
	},

	methods: {
		getCategoryOverviewData,
		getWasteSourceWithTranslations,
		loadData,
		printPage,
		generateExcel,
	},

	computed: {
		readyToPrint,
		...filtersGetters(["activeCompareTo"]),
	},

	beforeMount() {
		this.loadData();
		this.$eventBus.$on("reloadComponentData", this.loadData);
		this.$eventBus.$on("updateLanguage", this.loadData);
		this.getWasteSourceWithTranslations();
	},

	beforeDestroy() {
		this.$eventBus.$off("reloadComponentData", this.loadData);
		this.$eventBus.$off("updateLanguage", this.loadData);
	},
};

function getCategoryOverviewData() {
	const averageComparison = isAverageComparison(this.activeCompareTo);
	let currentData = [];

	this.categoryOverviewData = {};

	this.categoryOverviewDataStatus = {
		showLoader: true,
		dataLoadFailed: false,
	};

	CategoryService.getCategoryOverview()
		.then((response) => {
			currentData = response.data;
		})
		.then(() => {
			CategoryService.getCategoryOverview(true)
				.then((response) => {
					const compareData = response.data;

					currentData.forEach((currentCategory) => {
						const compareCategory = compareData.find(
							(compareCategory) => compareCategory.category_id === currentCategory.category_id
						);
						if (!compareCategory) {
							this.$utils.warn("There is not compare category for the current category:", currentCategory);
							return;
						}
						currentCategory.weight_comparison = averageComparison
							? comparator(currentCategory.wpg, compareCategory.wpg)
							: comparator(currentCategory.gross_weight, compareCategory.gross_weight);

						currentCategory.cost_comparison = averageComparison
							? comparator(currentCategory.cpg, compareCategory.cpg)
							: comparator(currentCategory.cost, compareCategory.cost);
					});

					this.categoryOverviewData = currentData;
				})
				.then(() => {
					this.categoryOverviewDataStatus.showLoader = false;

					// eslint-disable-next-line no-magic-numbers
					if (this.categoryOverviewData.length > 0) {
						this.categoryOverviewDataStatus.dataLoadFailed = false;
						this.categoryOverviewDataStatus.dataLoadFailed = false;
					} else this.categoryOverviewDataStatus.dataLoadFailed = true;
				})
				.catch(() => {
					this.categoryOverviewData = currentData;

					// eslint-disable-next-line no-magic-numbers
					if (this.categoryOverviewData.length > 0) {
						this.categoryOverviewDataStatus.showLoader = false;
						this.categoryOverviewDataStatus.dataLoadFailed = false;
					} else {
						this.categoryOverviewDataStatus.showLoader = false;
						this.categoryOverviewDataStatus.dataLoadFailed = true;
					}
				});
		})
		.catch((error) => {
			if (error.message !== "CANCELED_CALL") {
				this.categoryOverviewDataStatus.showLoader = false;
				// eslint-disable-next-line no-magic-numbers
				if (this.categoryOverviewData.length > 0) this.categoryOverviewDataStatus.dataLoadFailed = false;
				else this.categoryOverviewDataStatus.dataLoadFailed = true;
			}
		});
}

function getWasteSourceWithTranslations() {
	this.$api.getWasteSourceWithTranslations().then((response) => {
		this.wasteSourceWithTranslations = response.data;
	});
}

function loadData() {
	this.getCategoryOverviewData();
}

function printPage() {
	this.printReportOpen = false;
	this.$utils.printPage(this);
}

function readyToPrint() {
	return !this.categoryOverviewDataStatus.showLoader;
}

function generateExcel() {
	this.$api.generateCategoryOverviewExcel();
	this.printReportOpen = false;
	this.generateExcelModalShown = false;
}
